import { CouponUses } from './coupon.models';

export function buildCouponUses(
  feeAmounts: { currentMonthAmount: number; previousMonthAmount: number; },
  usageStats: { uses?: { currentMonth?: number; previousMonth?: number; }; }
): CouponUses {
  return {
    thisMonth: {
      count: usageStats?.uses?.currentMonth || 0,
      amount: feeAmounts.currentMonthAmount
    },
    lastMonth: {
      count: usageStats?.uses?.previousMonth || 0,
      amount: feeAmounts.previousMonthAmount
    }
  };
}
/**
 * Calculates the eligible amount for a coupon by subtracting the shipping amount from the total amount.
 * @param totalAmt The total amount before applying the coupon.
 * @param shippingAmt The shipping amount to be excluded from the coupon calculation.
 * @returns The eligible amount for the coupon.
 */
export function calculateCouponEligibleAmount(totalAmt: number, shippingAmt: number): number {
  return Number((totalAmt - shippingAmt).toFixed(2)); //FIXME pendiente de confirmar si es number o string
}
